module.exports = __webpack_public_path__ + "static/media/bochra.bbef4302.webp";